export default "/images/vendor/flag-icons/flags/1x1/fj.svg?b2513b571858e73a2f2bd2fc297c9375";